const init51la = (id) => {
  let s = document.createElement('script');
  s.type = 'text/javascript';
  s.src = `//js.users.51.la/${id}.js`;
  document.body.appendChild(s);
}

export default init51la;
